import { MembersIcons } from "app/components/Icons";
import { renderLetter } from "app/containers/Features/containers/TeamSettings/components/ProjectIconSelection/helper";
import { IWorkspaceTeams } from "app/types";
import React from "react";

interface Props {
  selectedTeam: IWorkspaceTeams;
}
const TeamSelection: React.FC<Props> = ({ selectedTeam }) => {
  const { avatar, teamName } = selectedTeam;
  return (
    <button className="flex items-center justify-between w-full px-2 py-2 rounded hover:bg-gray-400 space-x-2 ">
      <span className="flex gap-2 text-xs text-secondary items-center ">
        <MembersIcons size="20" color="#79808A" />
        Team:
      </span>
      <div className=" flex items-center justify-end gap-1 truncate ">
        <button
          style={{ backgroundColor: avatar.color }}
          className="flex !size-5 items-center justify-center rounded-[2px]"
        >
         {renderLetter(avatar, teamName, "", " text-secondary")}
        </button>
        <span className=" text-sm text-black font-normal truncate ">{teamName}</span>
      </div>
    </button>
  );
};

export default TeamSelection;
